import { PERSONAL_INFO, TERMS_OF_USE } from "utils/env-management"

export function PersonalInfoText({ text }: { text: string }) {
    return (
        <small className="personal-info">
            Нажимая &laquo;{text}&raquo;, вы&nbsp;принимаете условия{" "}
            <a
                className="personal-info__link"
                target="_blank"
                rel="noopener noreferrer"
                href={TERMS_OF_USE}
            >
                пользовательского соглашения
            </a>{" "}
            и&nbsp;даете свое согласие на&nbsp;обработку{" "}
            <a
                className="personal-info__link"
                target="_blank"
                rel="noopener noreferrer"
                href={PERSONAL_INFO}
            >
                персональных данных
            </a>
            .
        </small>
    )
}
